<script lang="ts">
	import { getHubStores } from '$lib/stores/hubStores';
	import ModalView from '$lib/components/Modal/ModalView.svelte';
	import { _ } from 'svelte-i18n';
	import HubPlaceHolder from '$lib/components/HubPlaceholder/HubPlaceHolder.svelte';
	import ResetPasswordForm from './ResetPasswordForm.svelte';
	import LoginForm from './LoginForm.svelte';
	import HubLogo from '$lib/Signin/HubLogo.svelte';
	import { createControlCenterUrl } from '$lib/utils/controlCenterUrl';

	const { hub, pod } = getHubStores();

	export let isResetPasswordFormDisplayed: boolean;
	export let isJoinCommunityFormDisplayed: boolean;
	export let isSparqAdminInfoModalDisplayed: boolean;
	export let isAlreadyMember: boolean;

	const controlCenterUrl: string = createControlCenterUrl(pod);
	const isEmailLoginEnabled = !$hub.settings.auth_options.disable_email_form;
	const isSsoLoginEnabled = $hub.sso_buttons?.length;
	const isLoginEnabled = isEmailLoginEnabled || isSsoLoginEnabled;
</script>

<ModalView>
	{#if !isResetPasswordFormDisplayed && !isSparqAdminInfoModalDisplayed}
		<div class="signInModal scroll">
			<HubLogo />

			<div class="title">
				{#if isAlreadyMember}
					{$_('hubs.signup.already.member')}
				{:else if isJoinCommunityFormDisplayed}
					{$_('session.join.the.community', { values: { hubName: $hub.name } })}
				{:else if isLoginEnabled}
					{$_('hubs.sign.in.page.title')}
				{/if}
			</div>
			<div class="heading">
				{#if isAlreadyMember}
					{$_('hubs.signup.already.member.msg', { values: { hubName: $hub.name } })}
				{:else}
					{$hub?.settings.welcome_message || ''}
				{/if}
			</div>
			<div>
				<LoginForm
					bind:isResetPasswordFormDisplayed
					bind:isJoinCommunityFormDisplayed
					bind:isSparqAdminInfoModalDisplayed
				/>
			</div>
		</div>
	{:else if isSparqAdminInfoModalDisplayed}
		<div class="sparqAdminInfoModal scroll">
			<HubLogo />

			<div class="title">{$_('session.cant.authenticate.here')}</div>
			<div class="heading">
				{@html $_('session.sparq.admin.cant.login', {
					values: {
						controlCenterLink: `<a href="${controlCenterUrl}">${controlCenterUrl}</a>`,
					},
				})}
			</div>
		</div>
	{:else if isResetPasswordFormDisplayed}
		<ResetPasswordForm bind:isResetPasswordFormDisplayed bind:isSparqAdminInfoModalDisplayed />
	{/if}
</ModalView>

<HubPlaceHolder />

<style>
	.signInModal,
	.sparqAdminInfoModal {
		display: flex;
		flex-direction: column;
		align-items: center;
		max-block-size: calc(100vh - 60px);
		padding: 50px;
	}

	.sparqAdminInfoModal {
		text-align: center;
	}

	.title {
		color: rgb(26 26 26);
		font-size: var(--fontSizeLarger);
		font-weight: 500;
	}

	.heading {
		max-inline-size: 600px;
		margin-block: var(--gutterLarge);
		margin-inline: 0;
		color: var(--detailColor);
		font-size: var(--fontSizeSmall);
		font-weight: 100;
		text-align: center;
	}

	@media screen and (max-width: 899px) {
		.signInModal {
			padding: 35px;
		}
	}
</style>
